import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { appActions, getApps, getSelectedApp } from "../appApi"
import { withRouter } from "react-router"

class WithApps extends React.Component {
    render() {
        const appsData = this.props.apps
        if (!appsData) return this.props.loading ? this.props.loading : ""
        const apps = Object.values(appsData)
        return this.props.children({
            apps,
            onChange: this.props.appActions.update,
            selectApp: this.selectApp,
            selectedApp: this.props.selectedApp,
        })
    }

    constructor(props) {
        super(props)
        props.appActions.fetch()
    }
    componentWillReceiveProps(newProps) {
        if (newProps.apps && newProps.apps.length && !newProps.selectedApp._sid) {
            var isSet = false
            console.log("trying each")
            newProps.apps.forEach(app => {
                if (this.props.router.location.pathname.indexOf(app._sid) !== -1) {
                    this.props.appActions.selectApp(app._sid)
                    console.log("selecting one")
                    isSet = true
                }
            })
            if (!isSet) {
                console.log("checking url")
                const location = this.props.router.location
                const appId = newProps.apps[0]._sid
                this.props.appActions.selectApp(appId)
                if (location && location.pathname.indexOf("undefined") !== -1) {
                    this.props.router.push(location.pathname.replace("undefined", appId))
                    console.log("changing url")
                }
            }
        }
    }

    selectApp = appId => {
        // If we're currently on an app indexed page, move it
        const location = this.props.router.location
        if (location && location.pathname.indexOf(this.props.selectedApp._sid) !== -1) {
            this.props.router.push(location.pathname.replace(this.props.selectedApp._sid, appId))
        }
        this.props.appActions.selectApp(appId)
    }
}

WithApps.propTypes = {}

function mapStateToProps(state) {
    return {
        apps: getApps(state),
        selectedApp: getSelectedApp(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
    }
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(WithApps)
)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithApps.js